import './create.css';

import * as React from 'react';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Memo from 'src/entities/Memo';

import CancelWhite from '../../res/img/cancel_white.svg';
import DeadlineRed from '../../res/img/deadline_red.svg';
import FistGreen from '../../res/img/fist_green.svg';
import Profile from '../../res/img/member.svg';
import MouthGreen from '../../res/img/mouth_green.svg';
import PencilGreen from '../../res/img/pencil_green.svg';
import TrashbinWhite from '../../res/img/trashbin_white.svg';
import MemberSelector from './memberSelector';

interface IProps {
  members: Member[];
  createMemo: (memo: Memo) => void;
  hideNewMemoForm: () => void;
  group: Group;
  account: Member;
  newMemo: Memo;
}

interface IState {
  memo: string;
  tags: string[];
  reporters: number[];
  performers: number[];
  watchers: number[];
  deadline: number | undefined;
  tagCandidates: string[];
}

class ItemComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      memo:
        this.props.newMemo.memo.length > 0
          ? this.props.newMemo.memo
          : this.props.group.memoFormat,
      tags: [],
      reporters: this.props.newMemo.reporters,
      performers: [],
      watchers: [],
      tagCandidates: ['MT', '下書き', '毎日報告'],
      deadline: undefined
    };

    this.addReporter = this.addReporter.bind(this);
    this.addPerformer = this.addPerformer.bind(this);
    this.addWatcher = this.addWatcher.bind(this);
    this.onChangeMemo = this.onChangeMemo.bind(this);
    this.onChangeDeadline = this.onChangeDeadline.bind(this);
    this.createMemo = this.createMemo.bind(this);
  }

  render() {
    return (
      <div id="NewMemo">
        <div className="Header">
          <div className="Id">新しいメモ</div>
          <div
            className="Cancel"
            onMouseUp={this.props.hideNewMemoForm}
            onTouchEnd={this.props.hideNewMemoForm}
          >
            <img src={CancelWhite} />
          </div>
        </div>
        <div className="Content">
          <div className="Memo">
            <div className="Tags">
              {this.state.tags.map(tag => (
                <div key={tag} className="Tag">
                  #{tag}
                </div>
              ))}
              <div className="TagCandidateTitle">よく使われているタグ：</div>
              <div className="TagCandidates">
                {this.state.tagCandidates.map(tag => (
                  <div
                    key={tag}
                    className="TagCandidate"
                    onClick={this.selectTagCandidate.bind(this, tag)}
                  >
                    #{tag}
                  </div>
                ))}
              </div>
            </div>
            <textarea
              className="Text"
              placeholder="ミーティングメモの内容"
              value={this.state.memo}
              onChange={this.onChangeMemo}
            />
          </div>
          <div className="MembersDetail">
            <div className="Reporters">
              <div className="Title">
                <img src={MouthGreen} />
                <span>報告責任者</span>
              </div>
              <div className="Members">
                {this.state.reporters.map(reporter =>
                  this.renderMemberItem(reporter, 'reporter')
                )}
                {this.state.reporters.length === 0 ? (
                  <div className="AddMember">
                    <MemberSelector
                      callback={this.addReporter}
                      members={this.props.members.filter(
                        member =>
                          this.props.group.members.includes(member.id) &&
                          !this.state.reporters.includes(member.id)
                      )}
                    />
                  </div>
                ) : null}
              </div>
            </div>

            <div className="Performers">
              <div className="Title">
                <img src={FistGreen} />
                <span>実行責任者</span>
              </div>
              <div className="Members">
                {this.state.performers.map(performer =>
                  this.renderMemberItem(performer, 'performer')
                )}
                <div className="AddMember">
                  <MemberSelector
                    callback={this.addPerformer}
                    members={this.props.members.filter(
                      member =>
                        this.props.group.members.includes(member.id) &&
                        !this.state.performers.includes(member.id)
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="Watchers">
              <div className="Title">
                <img src={FistGreen} />
                <span>注目</span>
              </div>
              <div className="Members">
                {this.state.watchers.map(watcher =>
                  this.renderMemberItem(watcher, 'watcher')
                )}
                <div className="AddMember">
                  <MemberSelector
                    callback={this.addWatcher}
                    members={this.props.members.filter(
                      member =>
                        this.props.group.members.includes(member.id) &&
                        !this.state.watchers.includes(member.id)
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="Others">
            <div className="Created">
              <img src={PencilGreen} />
              <span> {Utility.dateFormat(new Date(), 'M/d')}</span>
            </div>
            <div className="Deadline">
              <img src={DeadlineRed} />
              <input
                type="date"
                value={
                  this.state.deadline !== undefined
                    ? Utility.dateFormat(
                        new Date(this.state.deadline),
                        'yyyy-MM-dd'
                      )
                    : undefined
                }
                onChange={this.onChangeDeadline}
              />
            </div>
          </div>
        </div>
        <div className="Action">
          <button onMouseUp={this.createMemo} onTouchEnd={this.createMemo}>
            作成
          </button>
        </div>
      </div>
    );
  }
  onChangeMemo(e: any) {
    const memo = e.target.value;

    this.setState({
      memo,
      tags: Utility.extractTags(memo)
    });
  }

  onChangeDeadline(e: any) {
    if (e.target.value !== '') {
      this.setState({
        deadline: Date.parse(e.target.value)
      });
    }
  }

  addReporter(memberId: number) {
    this.setState({
      reporters: [...this.state.reporters, memberId]
    });
  }

  addPerformer(memberId: number) {
    this.setState({
      performers: [...this.state.performers, memberId]
    });
  }

  addWatcher(memberId: number) {
    this.setState({
      watchers: [...this.state.watchers, memberId]
    });
  }

  deleteReporter(memberId: number) {
    this.setState({
      reporters: this.state.reporters.filter(reporter => reporter !== memberId)
    });
  }

  deletePerformer(memberId: number) {
    this.setState({
      performers: this.state.performers.filter(
        performer => performer !== memberId
      )
    });
  }

  deleteWatcher(memberId: number) {
    console.log('aaa', memberId);
    this.setState({
      watchers: this.state.watchers.filter(watcher => watcher !== memberId)
    });
  }

  selectTagCandidate(tag: string, e: any) {
    if (!this.state.tags.includes(tag)) {
      this.setState({
        tags: [...this.state.tags, tag],
        memo: this.state.memo + ' #' + tag
      });
    }
  }

  createMemo() {
    const memo = new Memo();
    memo.memo = this.state.memo;
    memo.tags = this.state.tags;
    memo.reporters = this.state.reporters;
    memo.performers = this.state.performers;
    memo.watchers = this.state.watchers;
    memo.reportStatus = 1;
    memo.deadline = this.state.deadline !== undefined ? this.state.deadline : 0;
    memo.created = Date.now();
    memo.groupId = this.props.group.id;
    memo.memberId = this.props.account.id;

    this.props.createMemo(memo);

    if (
      this.state.memo.length > 0 &&
      this.state.performers.length > 0 &&
      this.state.reporters.length > 0
    ) {
      this.props.hideNewMemoForm();

      this.setState({
        memo: '',
        tags: [],
        reporters: [],
        performers: [],
        watchers: [],
        deadline: Date.now()
      });
    }
  }

  renderMemberItem(memberId: number, type: string) {
    const itemMember = this.props.members.find(
      member => member.id === memberId
    ) as Member;

    if (itemMember !== undefined) {
      return (
        <div className="MemberItem" key={memberId}>
          <img
            src={itemMember.profile !== null ? itemMember.profile : Profile}
          />
          <span>{itemMember.nameLast + itemMember.nameFirst}</span>
          <div
            className="Trashbin"
            onClick={
              type === 'reporter'
                ? this.deleteReporter.bind(this, memberId)
                : type === 'performer'
                ? this.deletePerformer.bind(this, memberId)
                : this.deleteWatcher.bind(this, memberId)
            }
          >
            <img src={TrashbinWhite} />
            <div className="Serif" />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/Memo/create.tsx